import { ErrorInfo } from '@bimser/common';
import { call } from 'redux-saga/effects';
import { callEndRequest } from './index';

export function handleServiceError(e: ErrorInfo, panelId?: string) {
	// console.log("LOG: handleServiceError -> e", e)
	return function* () {
		if (panelId) {
			yield call(callEndRequest, panelId);
		}
	};
}
